module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Toc_Link2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "SANS-BI"
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMCO-1"
  }, [_vm._v("My father, brothers, and I each had our own deep, complex, and loving relationship with my mother, Mama Jean. This book is the story of my relationship with her told through the lens of my love affair with alcohol, the other dominant relationship in my life. Hence, my father and brothers often have only cameos here, but in the cast of our family they each had as big a supporting role as I did to Mama Jean, the star of our lives. Some of the names and places have been changed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0795a6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 72
// module chunks = 0